module.exports = __webpack_public_path__ + "img/logo-app-cascajares.0733fdd1.svg";